import { render, staticRenderFns } from "./cmpy-list.vue?vue&type=template&id=0823811a&scoped=true"
import script from "./cmpy-list.vue?vue&type=script&lang=js"
export * from "./cmpy-list.vue?vue&type=script&lang=js"
import style0 from "./cmpy-list.vue?vue&type=style&index=0&id=0823811a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0823811a",
  null
  
)

export default component.exports